// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 60 60"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M22.5 28.7519L27.5 33.7519L38.75 22.5019M50 30.0019C50 42.273 36.6151 51.1979 31.745 54.0391C31.1915 54.362 30.9148 54.5234 30.5242 54.6072C30.2211 54.6722 29.7789 54.6722 29.4758 54.6072C29.0852 54.5234 28.8085 54.362 28.255 54.0391C23.3849 51.1979 10 42.273 10 30.0019V18.0459C10 16.0471 10 15.0477 10.3269 14.1886C10.6157 13.4297 11.085 12.7526 11.6941 12.2157C12.3837 11.608 13.3195 11.2571 15.191 10.5552L28.5955 5.52856C29.1152 5.33366 29.3751 5.23621 29.6425 5.19757C29.8796 5.16331 30.1204 5.16331 30.3575 5.19757C30.6249 5.23621 30.8848 5.33366 31.4045 5.52856L44.809 10.5552C46.6805 11.2571 47.6163 11.608 48.3059 12.2157C48.915 12.7526 49.3843 13.4297 49.6731 14.1886C50 15.0477 50 16.0471 50 18.0459V30.0019Z"
    />
  </svg>
);
const IconSuccessShield = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconSuccessShield;
